export default __webpack_public_path__ + "static/ethereum-hero-light-aa1003dec196f40e4af5ad67f9aa3f2a.mp4";